import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {OverlayService} from "../../../overlay/overlay.service";
import {YoutubeVideoOverlayComponent} from "../../youtube-video-overlay/youtube-video-overlay.component";
import {ObjectFit} from "../../../ts-types/object-fit";
import {GalleryItemData} from "../../gallery-preview/gallery-item-data";
import {ServerVideoService} from "../../../services/server-video.service";

@Component({
  selector: 'brt-gallery-item',
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss']
})
export class GalleryItemComponent implements AfterViewInit{
  @ViewChild("mainEl") mainEl = new ElementRef(null);
  @Output('loaded') loaded = new EventEmitter<void>();

  @Input("item") item!: GalleryItemData;
  @Input("object-fit") objectFit: ObjectFit = "contain";

  isLoaded = false;
  colors = ["#1e5f6e", "#2996d2", "#2064b4", "#128750", "#fa2027"];

  constructor(private overlay: OverlayService, private serverVideoService: ServerVideoService) {
  }

  ngAfterViewInit() {
    if(this.mainEl.nativeElement) {
      const htmlEl = this.mainEl.nativeElement as HTMLElement;
      htmlEl.style.backgroundColor = this.colors[Math.floor(Math.random() * this.colors.length)]
    }
  }

  openVideoOverlay($event: MouseEvent) {
    $event.stopPropagation();
    if(this.item.type === "video" && this.item.video) {
      this.overlay.addComponent({
        component: YoutubeVideoOverlayComponent,
        data: {'youtube-str': this.serverVideoService.getYoutubeIframeStringByVideo(this.item.video)}
      });
    }
  }

  itemLoaded() {
    this.isLoaded = true;
    this.loaded.emit();
  }
}
